// extracted by mini-css-extract-plugin
module.exports = {"text-info-block-1":"TextInfoBlock1_text-info-block-1__yFlvI","__cta":"TextInfoBlock1___cta__2oJ1M"};